'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breadcrumbsPathFactory = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _Breadcrumbs = require('./Breadcrumbs.scss');

var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);

var _classnames4 = require('classnames');

var _classnames5 = _interopRequireDefault(_classnames4);

var _WixComponent2 = require('../BaseComponents/WixComponent');

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _Text = require('../Text');

var _Text2 = _interopRequireDefault(_Text);

var _BreadcrumbsPathFactory = require('./BreadcrumbsPathFactory');

var _BreadcrumbsPathFactory2 = _interopRequireDefault(_BreadcrumbsPathFactory);

var _BreadcrumbsChevronRight = require('wix-ui-icons-common/system/BreadcrumbsChevronRight');

var _BreadcrumbsChevronRight2 = _interopRequireDefault(_BreadcrumbsChevronRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
  * a way to visualise current navigation path
  */
var Breadcrumbs = function (_WixComponent) {
  _inherits(Breadcrumbs, _WixComponent);

  function Breadcrumbs() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Breadcrumbs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Breadcrumbs.__proto__ || Object.getPrototypeOf(Breadcrumbs)).call.apply(_ref, [this].concat(args))), _this), _this.handleBreadcrumbClick = function (item) {
      return _this.props.onClick && _this.props.onClick(item);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Breadcrumbs, [{
    key: 'getValueAppearance',
    value: function getValueAppearance(isActive) {
      var _props = this.props,
          theme = _props.theme,
          size = _props.size;


      var isDarkBackground = theme === 'onDarkBackground';
      var isMediumSize = size === 'medium';

      if (isActive) {
        if (isMediumSize) {
          return isDarkBackground ? 'T4.2' : 'T4';
        } else {
          return isDarkBackground ? 'T2.2' : 'T2';
        }
      }

      if (isMediumSize) {
        return isDarkBackground ? 'T3.2' : 'T3.1';
      } else {
        return isDarkBackground ? 'T1.2' : 'T1.1';
      }
    }
  }, {
    key: 'createItem',
    value: function createItem(_ref2) {
      var _this2 = this;

      var item = _ref2.item,
          isActive = _ref2.isActive,
          onClick = _ref2.onClick;

      var breadcrumbValue = function breadcrumbValue(value) {
        return _react2.default.createElement(_Text2.default, {
          dataHook: 'breadcrumbs-item',
          appearance: _this2.getValueAppearance(isActive),
          children: value
        });
      };

      var defaultBreadcrumb = function defaultBreadcrumb() {
        var _classnames;

        return _react2.default.createElement('button', {
          type: 'button',
          'data-hook': 'breadcrumb-clickable',
          className: (0, _classnames5.default)(_Breadcrumbs2.default.item, _Breadcrumbs2.default.button, (_classnames = {}, _defineProperty(_classnames, _Breadcrumbs2.default.disabled, item.disabled), _defineProperty(_classnames, _Breadcrumbs2.default.active, isActive), _classnames)),
          onClick: onClick,
          children: breadcrumbValue(item.value)
        });
      };

      var linkBreadcrumb = function linkBreadcrumb() {
        var _classnames2;

        return _react2.default.createElement('a', {
          href: item.link,
          'data-hook': 'breadcrumb-clickable',
          className: (0, _classnames5.default)(_Breadcrumbs2.default.item, _Breadcrumbs2.default.link, (_classnames2 = {}, _defineProperty(_classnames2, _Breadcrumbs2.default.disabled, item.disabled), _defineProperty(_classnames2, _Breadcrumbs2.default.active, isActive), _classnames2)),
          onClick: onClick,
          children: breadcrumbValue(item.value)
        });
      };

      var customBreadcrumb = function customBreadcrumb() {
        return _react2.default.createElement('span', {
          'data-hook': 'breadcrumb-clickable',
          className: _Breadcrumbs2.default.item,
          onClick: onClick,
          children: breadcrumbValue(item.customElement)
        });
      };

      if (isActive) {
        return defaultBreadcrumb();
      } else if (item.customElement) {
        return customBreadcrumb();
      } else if (item.link) {
        return linkBreadcrumb();
      } else {
        return defaultBreadcrumb();
      }
    }
  }, {
    key: 'renderItem',
    value: function renderItem(item, activeId, isDividerVisible) {
      var _this3 = this;

      var isActive = activeId === item.id;

      return _react2.default.createElement(
        'div',
        {
          key: item.id,
          className: (0, _classnames5.default)(_Breadcrumbs2.default.itemContainer, _defineProperty({}, _Breadcrumbs2.default.active, isActive))
        },
        this.createItem({ item: item, isActive: isActive, onClick: function onClick() {
            return item.disabled !== true && _this3.handleBreadcrumbClick(item);
          } }),
        isDividerVisible && _react2.default.createElement(_BreadcrumbsChevronRight2.default, { className: _Breadcrumbs2.default.divider })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          items = _props2.items,
          size = _props2.size,
          theme = _props2.theme,
          activeId = _props2.activeId;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames5.default)(_Breadcrumbs2.default[size], _Breadcrumbs2.default[theme]) },
        items.map(function (item, i, allItems) {
          return _this4.renderItem(item, activeId, allItems[i + 1]);
        })
      );
    }
  }]);

  return Breadcrumbs;
}(_WixComponent3.default);

Breadcrumbs.displayName = 'Breadcrumbs';
Breadcrumbs.propTypes = {
  /**
    * * __id__ - Specifies the item id
    * * __link__ - Optional link to be called on click
    * * __value__ - Value to be shown on breadcrumb
    * * __disabled__ - if this value is disabled
    * * __customElement__ - A custom item which will be rendered
    */
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired,
    value: _propTypes.node.isRequired,
    link: _propTypes.string,
    customElement: _propTypes.any,
    disabled: _propTypes.bool
  })).isRequired,
  onClick: _propTypes.func,
  activeId: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  size: (0, _propTypes.oneOf)(['medium', 'large']),
  theme: (0, _propTypes.oneOf)(['onWhiteBackground', 'onGrayBackground', 'onDarkBackground'])
};
Breadcrumbs.defaultProps = {
  size: 'medium',
  theme: 'onGrayBackground'
};
var breadcrumbsPathFactory = exports.breadcrumbsPathFactory = _BreadcrumbsPathFactory2.default;
exports.default = Breadcrumbs;